export default __webpack_public_path__ + "static/media/text-allign-right.3b563169.svg";